/* eslint-disable filenames/match-exported */
import React from 'react';
import cn from '@src/util/cnHelper';

function Skeleton({className, ...props}: React.HTMLAttributes<HTMLDivElement>) {
  return <div className={cn('animate-pulse rounded-md bg-primary/10', className)} {...props} />;
}

export default Skeleton;
